export type CreateReportDialogTrigger =
  | { source: 'row'; findingId: string }
  | { source: 'toolbar' };

type ReportDialogSelection =
  | { mode: 'ids'; ids: Set<string> }
  | { mode: 'filter' };

export function getCreateReportDialogPayload({
  trigger,
  selection,
  selectedCount,
}: {
  trigger: CreateReportDialogTrigger | null;
  selection: ReportDialogSelection;
  selectedCount: number;
}): {
  count: number;
  ids: string[];
  canCreateNew: boolean;
} {
  if (trigger?.source === 'row') {
    return {
      count: 1,
      ids: [trigger.findingId],
      canCreateNew: true,
    };
  }

  if (trigger?.source === 'toolbar') {
    return {
      count: selectedCount,
      ids: selection.mode === 'ids' ? Array.from(selection.ids) : [],
      canCreateNew: selection.mode === 'ids',
    };
  }

  return {
    count: 0,
    ids: [],
    canCreateNew: false,
  };
}
